import { RootState } from '../../Store';
import { useSelector } from 'react-redux';

export const useGetExportPdfRequest = (): boolean => useSelector<RootState, boolean>(state => state.pdf.printRequested);
